import "../../../../src/pages/design/design-guidelines-styles.css";
import * as React from 'react';
export default {
  React
};